import React, { useEffect, useState } from "react";
import tw from "tailwind-styled-components";
import {compressAmount} from "../../helpers";

const DuesNav = ({ data }) => {
  const [summaryData, setSummaryData] = useState({
    totalDues: 0,
    currentMonthAmount: 0,
    currentMonthRent: 0,
    currentMonthSecurity: 0,
    overdueAmount: 0,
    electricity: 0,
  });

  useEffect(() => {
    if (data && typeof data === "object") {
      setSummaryData((prev) => ({
        ...prev,
        ...data,
      }));
    }
  }, [data]);

  const currentMonthName = new Date().toLocaleString("default", {
    month: "short",
  });

  return (
    <BookingSummary>
      <BookingGrid>
        <BoxComp
          value={summaryData.totalDues}
          title="Total Dues"
          className="bg-rose-50 text-rose-400 border-b-rose-400"
        />
        <BoxComp
          value={summaryData.currentMonthAmount}
          title={`${currentMonthName} Amount`}
          className="bg-green-50 text-green-400 border-b-green-400"
        />
        <BoxComp
          value={summaryData.currentMonthRent}
          title={`${currentMonthName} Rent`}
          className="bg-blue-50 text-blue-400 border-b-blue-400"
        />
        <BoxComp
          value={summaryData.currentMonthSecurity}
          title={`${currentMonthName} Security`}
          className="bg-yellow-50 text-yellow-400 border-b-yellow-400"
        />
        <BoxComp
          value={summaryData.overdueAmount}
          title="Over Dues"
          className="bg-red-50 text-red-400 border-b-red-400"
        />
        <BoxComp
          value={summaryData.electricity}
          title="Electricity"
          className="bg-teal-50 text-teal-400 border-b-teal-400"
        />
      </BookingGrid>
    </BookingSummary>
  );
};

const BoxComp = ({ value, title, className, icon }) => (
  <Box className={`border-b-4 shadow-xl ${className} `}>
    <BoxTitle>
      {title.trim()}
      <hr className={`${className} w-1/3 border-b-2 rounded-full`} />
    </BoxTitle>

    <BoxCount>
      <p>{compressAmount(value || 0)}</p>
    </BoxCount>
  </Box>
);

const BookingSummary = tw.div``;
const Title = tw.h1`xl:text-2xl lg:text-md text-sm  text-gray-800   font-medium`;
const SubTitle = tw.h4`text-sm text-gray-100 mt-1.5`;
const BookingGrid = tw.div`grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 mt-10 gap-6 lg:gap-6`;
const Box = tw.div`w-full min-h-32  rounded-lg shadow-md flex flex-col p-4 justify-between  relative hover:scale-105 transition`;
const BoxTitle = tw.h3`text-sm sm:text-md lg:text-md font-medium text-left absolute inset-4 uppercase text-zinc-500 font-semibold`;
const BoxCount = tw.span`font-semibold xl:text-[26px] text-[32px] mt-auto`;

export default DuesNav;